module.exports = __webpack_public_path__ + "fonts/bold.e21cf48.eot";